function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import __ from 'ramda/src/__';
import CustomerCareKeys from '../../../../../locales/keys';
import { CurrentBusinessUnitTimeZoneOffsetSelector } from 'invision-core/src/components/session/businessunit.selectors';
import { find, last, propEq, remove } from 'ramda';
import { CoreLocaleKeys, i18n, PermissionService, SessionSelectors } from 'invision-core';
import { ScheduleTypes } from '../decisions.constants';
import { BulkChargeTypes } from '../../../newConnectWizard/new.connect.wizard.constants';
import { PRICE_OVERRIDE_ACCESS } from '../../../../../security.attributes';
import { OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import moment from 'moment';
function EditDecisionOptionController($ngRedux, $timeout) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      currentBUTimeZoneOffset: CurrentBusinessUnitTimeZoneOffsetSelector(store),
      userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store),
      pricingPlanMetadata: OfferingMetadataPricingPlansSelector(store)
    };
  };
  var controllerActions = {};
  var popupApi = null;
  this.$onInit = function () {
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.coreLocaleKeys = CoreLocaleKeys;
    _this.customerCareKeys = CustomerCareKeys;
    _this.showForm = false;

    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.showForm = true;
          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            _this.resetForm();
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
    _this.scheduleTypes = ScheduleTypes;
    _this.hasPriceOverrideAccess = PermissionService.hasAccess(_this.state.userSecurityAttributes, PRICE_OVERRIDE_ACCESS);
  };
  this.restoreDefaultPricing = function () {
    _this.restoreOptionDefaultPricing()(_this.editOption.Id);
  };
  this.getName = function (option, brit) {
    return _this.state.pricingPlanMetadata[option.PricingPlanId].BillerRuleInstanceThumbnails.find(function (MetaDataBrit) {
      return MetaDataBrit.Id === brit.Id;
    }).Name;
  };
  this.allowPlanOrServiceSwap = function () {
    if (_this.editOption) {
      return _this.isModify && _this.editOption.Bulk && _this.editOption.HasServiceIdentifier;
    }
  };
  this.disableUpdatePricingInvalid = function () {
    var disableForm = false;
    _this.editOption && _this.editOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
      if (brit.scheduleType === _this.scheduleTypes.CUSTOM) {
        disableForm = _this.disableInvalidMinMaxDates(brit);
      }
      if (last(brit.pricingPeriods).EndDate) {
        disableForm = true;
      }
    });
    if (_this.formApi.$invalid) {
      disableForm = _this.formApi.$invalid;
    }
    return disableForm;
  };
  this.disableInvalidMinMaxDates = function (brit) {
    brit.pricingPeriods.forEach(function (period, index) {
      period.disabled = false;
      var startDate = period.StartDate ? new Date(period.StartDate).getTime() : null;
      var endDate = period.EndDate ? new Date(period.EndDate).getTime() : null;
      var startMinDate = _this.getStartDateMinDate(brit, index) ? new Date(_this.getStartDateMinDate(brit, index)).getTime() : null;
      var startMaxDate = _this.getStartDateMaxDate(brit, index) ? new Date(_this.getStartDateMaxDate(brit, index)).getTime() : null;
      var endMinDate = _this.getEndDateMinDate(brit, index) ? new Date(_this.getEndDateMinDate(brit, index)).getTime() : null;
      var endMaxDate = _this.getEndDateMaxDate(brit, index) ? new Date(_this.getEndDateMaxDate(brit, index)).getTime() : null;
      if (startDate && startDate < startMinDate) {
        period.disabled = true;
      }
      if (startMaxDate && startDate > startMaxDate) {
        period.disabled = true;
      }

      // the last row's end date will have a minimum but must be empty
      if (index === brit.pricingPeriods.length - 1) {
        if (endDate) {
          period.disabled = true;
        }
      } else {
        if (endDate && endDate < endMinDate) {
          period.disabled = true;
        }
        if (endMaxDate && endDate > endMaxDate) {
          period.disabled = true;
        }
      }
      if (!period.StartDate && !period.EndDate) {
        period.disabled = true;
      }
    });
    if (brit.pricingPeriods.some(function (period) {
      return period.disabled;
    })) {
      return true;
    }
    return false;
  };
  this.savePricing = function () {
    if (_this.isModify) {
      _this.editOption = Object.assign({}, _this.editOption, {
        isPlanOrServiceSwap: _this.isPlanOrServiceChange
      });
      _this.saveOptionEdit()(_this.editOption);
      _this.setEditOption()(_this.editOption);
    }
    _this.saveBulkPricing()(_this.editOption);
    _this.updateCart()(function () {
      _this.closePopup();
    });
  };
  this.cancelEditPricing = function () {
    _this.closePopup();
  };
  this.onPriceChange = function () {
    var params = [];
    if (_this.editOption && _this.editOption.BillerRuleInstanceThumbnails.length) {
      _this.editOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
        var britObj = {
          optionId: _this.editOption.Id,
          brcId: brit.BillerRuleConfigurationId,
          pricingPeriods: brit.pricingPeriods,
          scheduleType: brit.scheduleType
        };
        params.push(britObj);
      });
      _this.updateEditOptionPrice()(params);
    }
  };
  this.changeScheduleType = function (brit) {
    if (brit.scheduleType === _this.scheduleTypes.NONE) {
      brit.pricingPeriods = [_this.buildDefaultPricingPeriod(brit)];
    }
    _this.onPriceChange();
  };
  this.addPricingPeriod = function (brit) {
    var newPricingPeriod = _this.buildDefaultPricingPeriod(brit);
    newPricingPeriod.StartDate = last(brit.pricingPeriods).EndDate;
    brit.pricingPeriods.push(newPricingPeriod);
  };
  this.buildDefaultPricingPeriod = function (brit) {
    return {
      Amount: brit.Amount,
      ChargeAmount: brit.Amount,
      EndDate: null,
      Quantity: _this.editOption.Quantity,
      StartDate: null
    };
  };
  this.removePricingPeriod = function (brit, index) {
    brit.pricingPeriods = remove(index, 1, brit.pricingPeriods);
  };
  this.formatTimeWithBuTimeOffset = function (date) {
    var browserTimeZoneOffsetMinutes = new Date().getTimezoneOffset();
    var buTimezoneOffsetMinutes = moment.duration(_this.state.currentBUTimeZoneOffset).asMinutes();
    return moment(date).utc().utcOffset(browserTimeZoneOffsetMinutes + Number(buTimezoneOffsetMinutes), true).toISOString();
  };
  this.onStartDateChanged = function (brit, index, date) {
    brit.pricingPeriods[index].StartDate = _this.formatTimeWithBuTimeOffset(date);
    _this.onPriceChange();
  };
  this.onEndDateChanged = function (brit, index, date) {
    brit.pricingPeriods[index].EndDate = _this.formatTimeWithBuTimeOffset(date);
    _this.onPriceChange();
  };
  this.getStartDateMinDate = function (brit, index) {
    if (index > 0) {
      return brit.pricingPeriods[index - 1].EndDate || brit.pricingPeriods[index - 1].StartDate;
    }
    return moment().startOf('day').toISOString();
  };
  this.getStartDateMaxDate = function (brit, index) {
    if (index > 0 && (brit.pricingPeriods[index - 1].EndDate || brit.pricingPeriods[index - 1].StartDate)) {
      return brit.pricingPeriods[index - 1].EndDate || brit.pricingPeriods[index - 1].StartDate;
    }
    if (brit.pricingPeriods[index].EndDate) {
      return brit.pricingPeriods[index].EndDate;
    }
    if (brit.pricingPeriods[+1 + index]) {
      return brit.pricingPeriods[+1 + index].StartDate || brit.pricingPeriods[+1 + index].EndDate;
    }
    return null;
  };
  this.getEndDateMinDate = function (brit, index) {
    if (index > 0 && (brit.pricingPeriods[index - 1].EndDate || brit.pricingPeriods[index - 1].StartDate)) {
      return brit.pricingPeriods[index - 1].EndDate || brit.pricingPeriods[index - 1].StartDate;
    }
    if (brit.pricingPeriods[+1 + index] && brit.pricingPeriods[+1 + index].StartDate) {
      return brit.pricingPeriods[+1 + index].StartDate;
    }
    if (brit.pricingPeriods[index].StartDate) {
      return brit.pricingPeriods[index].StartDate;
    }
    if (brit.pricingPeriods[+1 + index] && brit.pricingPeriods[+1 + index].EndDate) {
      return brit.pricingPeriods[+1 + index].EndDate;
    }
    return moment().startOf('day').toISOString();
  };
  this.getEndDateMaxDate = function (brit, index) {
    if (brit.pricingPeriods[+1 + index]) {
      return brit.pricingPeriods[+1 + index].StartDate || brit.pricingPeriods[+1 + index].EndDate;
    }
    return null;
  };
  this.closePopup = function () {
    popupApi.close();
    _this.showForm = false;
  };
  this.restoreDefaults = function (e) {
    e.preventDefault();
    _this.editOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
      brit.pricingPeriods = [_this.buildDefaultPricingPeriod(brit)];
      brit.scheduleType = _this.scheduleTypes.NONE;
    });
  };
  this.resetForm = function () {
    _this.popupTitle = "".concat(i18n.translate(_this.customerCareKeys.EDIT_BULK_PLAN.EDIT_BULK_PRICING), " ").concat(_this.editOption.Name);
    _this.editOption.BillerRuleInstanceThumbnails.forEach(function (brit) {
      brit.scheduleType = brit.scheduleType || _this.scheduleTypes.NONE;
    });
    _this.isPlanOrServiceChange = _this.editOption.isPlanOrServiceSwap;
  };
  this.getDefaultAmount = function (brcId) {
    var brit = find(propEq(brcId, 'BillerRuleConfigurationId'))(_this.editOption.defaultAmounts);
    return brit.CatalogAmount;
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.getIconClass = function (billerRuleInstanceThumbnail) {
    return billerRuleInstanceThumbnail.BulkChargeTypeCode === BulkChargeTypes.FLAT ? 'filled-circle-f' : 'filled-circle-u';
  };
  this.showAmountField = function (briScheduleType) {
    return briScheduleType === _this.scheduleTypes.NONE;
  };
  this.showSchedulePeriods = function (briScheduleType) {
    return briScheduleType === _this.scheduleTypes.CUSTOM;
  };
  this.showBriAmount = function (brit) {
    if (_this.editOption.Bulk) {
      return true;
    }
    var filteredBris = _this.editOption.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(_this.editOption.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(_this.editOption.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances)) : [];
    return filteredBris.find(function (bri) {
      return bri.BillerRuleConfigurationId === brit.BillerRuleConfigurationId && bri.AllowChargeOverride;
    });
  };
}
export default {
  template: require('./edit.decision.option.popup.html'),
  bindings: {
    config: '<',
    editOption: '<',
    isModify: '<',
    restoreOptionDefaultPricing: '&',
    saveOptionEdit: '&',
    saveBulkPricing: '&',
    setEditOption: '&',
    updateCart: '&',
    updateEditOptionPrice: '&'
  },
  controllerAs: 'EditDecisionOptionController',
  controller: EditDecisionOptionController
};